import React from 'react';
import { Instagram, Facebook, Linkedin, Youtube, MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-800 text-white" data-id="element-138">
      {/* NAP block */}
      <div className="border-b border-white/10" data-id="element-139">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16" data-id="element-140">
          <div className="grid lg:grid-cols-12 gap-10" data-id="element-141">
            <div className="lg:col-span-5" data-id="element-142">
              <div className="text-3xl font-extrabold tracking-tight text-white mb-2" data-id="element-143">
                Langler Air
              </div>
              <div className="text-xs font-semibold uppercase tracking-widest text-accent mb-5" data-id="element-144">
                Mitsubishi Diamond Dealer
              </div>
              <p className="text-xl font-bold tracking-tight leading-tight text-white/95 max-w-md" data-id="element-145">
                Perth aircon, installed right since 1995. Family run from
                Balcatta.
              </p>
            </div>

            <div className="lg:col-span-7 grid sm:grid-cols-2 gap-8" data-id="element-146">
              <div className="space-y-4" data-id="element-147">
                <div className="text-[11px] uppercase tracking-widest font-semibold text-white/60" data-id="element-148">
                  Workshop
                </div>
                <div className="flex items-start gap-3" data-id="element-149">
                  <MapPin size={17} className="text-accent mt-0.5 flex-shrink-0" data-id="element-150" />
                  <a href="https://maps.google.com/?q=Unit+2%2F3+Cressall+Rd%2C+Balcatta+WA+6021" target="_blank" rel="noopener noreferrer" className="text-base text-white hover:text-accent transition-colors leading-snug" data-id="element-151">
                    Unit 2/3 Cressall Rd
                    <br data-id="element-152" />
                    Balcatta WA 6021
                  </a>
                </div>
                <div className="flex items-start gap-3" data-id="element-153">
                  <Clock size={17} className="text-accent mt-0.5 flex-shrink-0" data-id="element-154" />
                  <span className="text-base text-white leading-snug" data-id="element-155">
                    Mon–Thu 9am–4pm
                    <br data-id="element-156" />
                    Fri 9am–2pm
                  </span>
                </div>
              </div>

              <div className="space-y-4" data-id="element-157">
                <div className="text-[11px] uppercase tracking-widest font-semibold text-white/60" data-id="element-158">
                  Contact
                </div>
                <a href="tel:+61864043888" className="flex items-center gap-3 group" data-id="element-159">
                  <Phone size={17} className="text-accent flex-shrink-0" data-id="element-160" />
                  <span className="text-base text-white group-hover:text-accent transition-colors tabular-nums font-bold" data-id="element-161">
                    08 6404 3888
                  </span>
                </a>
                <a href="mailto:info@langlerair.com.au" className="flex items-center gap-3 group" data-id="element-162">
                  <Mail size={17} className="text-accent flex-shrink-0" data-id="element-163" />
                  <span className="text-base text-white group-hover:text-accent transition-colors" data-id="element-164">
                    info@langlerair.com.au
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Link columns */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16" data-id="element-165">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-166">
          <div data-id="element-167">
            <h4 className="text-[11px] uppercase tracking-widest font-semibold text-white/60 mb-5" data-id="element-168">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-169">
              <li data-id="element-170">
                <a href="/ducted-air-conditioning/" className="text-white/90 hover:text-accent transition-colors" data-id="element-171">
                  Ducted reverse cycle
                </a>
              </li>
              <li data-id="element-172">
                <a href="/split-systems-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-173">
                  Split systems
                </a>
              </li>
              <li data-id="element-174">
                <a href="/reverse-cycle-air-conditioning-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-175">
                  Reverse cycle
                </a>
              </li>
              <li data-id="element-176">
                <a href="/commercial-air-conditioning-installation-in-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-177">
                  Commercial HVAC
                </a>
              </li>
              <li data-id="element-178">
                <a href="/air-conditioner-removals/" className="text-white/90 hover:text-accent transition-colors" data-id="element-179">
                  Removal and disposal
                </a>
              </li>
              <li data-id="element-180">
                <a href="/smart-zone/" className="text-white/90 hover:text-accent transition-colors" data-id="element-181">
                  Smart Zone control
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-182">
            <h4 className="text-[11px] uppercase tracking-widest font-semibold text-white/60 mb-5" data-id="element-183">
              Brands
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-184">
              <li data-id="element-185">
                <a href="/brand/mitsubishi-air-conditioner-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-186">
                  Mitsubishi Electric
                </a>
              </li>
              <li data-id="element-187">
                <a href="/brand/daikin-air-conditioning-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-188">
                  Daikin
                </a>
              </li>
              <li data-id="element-189">
                <a href="/brand/rinnai-air-conditioning-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-190">
                  Rinnai HRV
                </a>
              </li>
              <li data-id="element-191">
                <a href="/smart-zone/" className="text-white/90 hover:text-accent transition-colors" data-id="element-192">
                  iZone Smart Home
                </a>
              </li>
              <li data-id="element-193">
                <a href="/best-ducted-air-conditioning-2026/" className="text-white/90 hover:text-accent transition-colors" data-id="element-194">
                  Best ducted 2026
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-195">
            <h4 className="text-[11px] uppercase tracking-widest font-semibold text-white/60 mb-5" data-id="element-196">
              Company
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-197">
              <li data-id="element-198">
                <a href="#meet-mike" className="text-white/90 hover:text-accent transition-colors" data-id="element-199">
                  About Mike
                </a>
              </li>
              <li data-id="element-200">
                <a href="#pricing" className="text-white/90 hover:text-accent transition-colors" data-id="element-201">
                  Pricing
                </a>
              </li>
              <li data-id="element-202">
                <a href="#reviews" className="text-white/90 hover:text-accent transition-colors" data-id="element-203">
                  Reviews
                </a>
              </li>
              <li data-id="element-204">
                <a href="/contact/" className="text-white/90 hover:text-accent transition-colors" data-id="element-205">
                  Contact
                </a>
              </li>
              <li data-id="element-206">
                <a href="/contact/" className="text-white/90 hover:text-accent transition-colors" data-id="element-207">
                  Service areas
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-208">
            <h4 className="text-[11px] uppercase tracking-widest font-semibold text-white/60 mb-5" data-id="element-209">
              Follow
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-210">
              <li data-id="element-211">
                <a href="https://www.instagram.com/LanglerAir/" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-accent transition-colors inline-flex items-center gap-2" data-id="element-212">
                  <Instagram size={15} data-id="element-213" /> Instagram
                </a>
              </li>
              <li data-id="element-214">
                <a href="https://www.facebook.com/langlerair/" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-accent transition-colors inline-flex items-center gap-2" data-id="element-215">
                  <Facebook size={15} data-id="element-216" /> Facebook
                </a>
              </li>
              <li data-id="element-217">
                <a href="https://www.linkedin.com/company/langler-air/" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-accent transition-colors inline-flex items-center gap-2" data-id="element-218">
                  <Linkedin size={15} data-id="element-219" /> LinkedIn
                </a>
              </li>
              <li data-id="element-220">
                <a href="https://www.youtube.com/@langlerair" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-accent transition-colors inline-flex items-center gap-2" data-id="element-221">
                  <Youtube size={15} data-id="element-222" /> YouTube
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10" data-id="element-223">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 text-xs text-white/60" data-id="element-224">
          <div className="tabular-nums" data-id="element-225">
            ABN 87 134 927 585 · ©2026 Langler Air Pty Ltd
          </div>
          <div className="flex items-center gap-5" data-id="element-226">
            <a href="/privacy/" className="hover:text-accent transition-colors" data-id="element-227">
              Privacy
            </a>
            <a href="/terms/" className="hover:text-accent transition-colors" data-id="element-228">
              Terms
            </a>
            <span data-id="element-229">Perth, Western Australia</span>
          </div>
        </div>
      </div>
    </footer>;
}